import React from 'react';

const AddressDisplay = ({ address }) =>
  <div className="address-display">
    <div>{address.name}</div>
    <div>{address.address1}</div>
    <div>{address.city}, {address.state} {address.postal_code}</div>
  </div>
;

export default AddressDisplay;




/** WEBPACK FOOTER **
 ** ./src/views/checkout/AddressDisplay.js
 **/